import * as Views from "./views";


const Module = {
    name: "contracts",
    defaultRoutePath: "/cars/contract",
    menuItemScope: "fleet",
    menuItemName: "contracts",

    routes: [
        {
            path: "/cars/contract",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Views.Default,
                },
                {
                    path: "list",
                    Component: Views.List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: Views.List,
        },
        {
            path: "detail",
            Component: Views.Detail,
        },
        {
            path: "create",
            Component: Views.Create,
        },
        {
            path: "serviceAssociation",
            Component: Views.ServiceAssociation,
        },
        {
            path: "serviceDissociation",
            Component: Views.ServiceDissociation,
        },
        {
            path: "contractExtension",
            Component: Views.ContractExtension,
        }
    ],
   
}

export default Module;
